(function () {
  const SECOND = 1000;
  const MINUTE = 60 * SECOND;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  // Time left until endIso, split into units. Null when the date is empty, invalid or already reached.
  function computeRemaining(endIso, nowMs) {
    const endMs = Date.parse(endIso);
    if (!endIso || Number.isNaN(endMs)) return null;

    const distance = endMs - nowMs;
    if (distance <= 0) return null;

    return {
      days: Math.floor(distance / DAY),
      hours: Math.floor((distance % DAY) / HOUR),
      mins: Math.floor((distance % HOUR) / MINUTE),
      secs: Math.floor((distance % MINUTE) / SECOND),
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { computeRemaining };
    return;
  }

  if (customElements.get('countdown-timer')) return;

  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.endIso = this.dataset.end || '';
        this.banner = this.closest('[data-countdown-banner]');
        this.tick();
        if (this.remaining) this.interval = setInterval(() => this.tick(), SECOND);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        this.remaining = computeRemaining(this.endIso, Date.now());
        if (!this.remaining) {
          this.expire();
          return;
        }
        for (const unit of ['days', 'hours', 'mins', 'secs']) {
          const el = this.querySelector(`[data-unit="${unit}"]`);
          if (el) el.textContent = String(this.remaining[unit]).padStart(2, '0');
        }
      }

      expire() {
        clearInterval(this.interval);
        const expiredText = this.dataset.expiredText;
        if (expiredText && this.banner) {
          this.banner.querySelector('[data-countdown-expired]').textContent = expiredText;
          this.banner.classList.add('countdown-banner--expired');
        } else if (this.banner) {
          this.banner.hidden = true;
        }
      }
    }
  );
})();
